import React, { useState, useEffect, useContext } from "react";
import { Card, Table, Button, Form} from "react-bootstrap";
import NotyfContext from "../contexts/NotyfContext";
import { X, Check, Edit2, Trash2} from "react-feather";
import Select from "react-select";

import { useTable, useSortBy, useFilters} from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSort,
  faSortUp,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";

import authenticatedFetch from "../utils/fetch"
import { caseInsensitiveSort } from "./reactTableUtils";


const TreatmentModalitySelect = ({ providerId, handleTreatmentModalityChanged, selectedTreatmentModality}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);
  
    useEffect(() => {
        authenticatedFetch({
            path: "treatmentmodality/all/" + providerId,
                successHandler: function(result) {
                setIsLoaded(true);
                setData(result);
            },
            errorHandler: function(error) {
                setIsLoaded(true);
                setError(error);
            }
        });
    }, [])
  
    const options = data.map((aoe) => {
        return {value: aoe.id, label: aoe.description};
    });

    if (!isLoaded)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
    }
    else if (error || !data)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
    }
    else
    {
        return (
            <div style={{width: "300px"}}>
                <Select
                options={options}
                onChange={(selectedTreatmentModality) => {
                    handleTreatmentModalityChanged(selectedTreatmentModality);
                }}
                value={[selectedTreatmentModality]}
                placeholder="Select..."
                isMulti={false}
                isClearable={true}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                  ...theme.colors,
                    primary50: '#DEF2F1',
                    primary25: '#DEF2F1',
                    primary: '#3AAFA9',
                  },
                })}
                />
            </div>
        )
    }
}

const ProviderTreatmentModality = ({ id, providerId, treatmentModalityId, description, refreshList, canEdit, onCancelEdit, startInEditMode=false }) => {
  const [editing, setEditing] = useState(startInEditMode);
  const [localTreatmentModalityId, setLocalTreatmentModalityId] = useState(treatmentModalityId);
  const [localDescription, setLocalDescription] = useState(description);
  
  const notyf = useContext(NotyfContext);

  function handleDeleteClicked(e) {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete this treatment modality?"))
    {
      authenticatedFetch({
        method: "DELETE",
        path: "treatmentmodality/" + providerId + "/" + id,
        successHandler: function(result) {
          refreshList();
        },
        errorHandler: function(error) {
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
    }
  }

  function handleEditClicked(e) {
    e.preventDefault();
    setEditing(true);
  }

  function cancelEdit(e) {
    e.preventDefault();
    setEditing(false);
    setLocalTreatmentModalityId(treatmentModalityId);
    setLocalDescription(description);
    

    if (onCancelEdit)
    {
      onCancelEdit();
    }
  }

  function saveEdit(e) {
    e.preventDefault();
    if (localTreatmentModalityId <= 0 || localDescription.length === 0)
    {
      alert("Please select a description");
      return;
    }

    setEditing(false);

    if (treatmentModalityId !== localTreatmentModalityId)
    {
      authenticatedFetch({
        method: id ? "PUT" : "POST",
        requestData: {providerId: parseInt(providerId), treatmentModalityId: localTreatmentModalityId},
        path: id ? "treatmentmodality/" + id  : "treatmentmodality",
        successHandler: function(result) {
          refreshList();
          notyf.open({type: "success", message: id ? "Updated!" : "Saved!", duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
        },
        errorHandler: function() {
          setEditing(true);
          setLocalTreatmentModalityId(treatmentModalityId);
          setLocalDescription(description);
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
    }
  }

  const handleTreatmentModalityChanged = (treatmentModalityDict) => {
    // Comes as a dict when not set to multi

    if (treatmentModalityDict == null)
    {
      setLocalTreatmentModalityId(0);
      setLocalDescription("");
    }
    else
    {
      setLocalTreatmentModalityId(treatmentModalityDict.value);
      setLocalDescription(treatmentModalityDict.label);
    }
  }

  var selectedTreatmentModalityTransformed = null;
  if (localTreatmentModalityId && localTreatmentModalityId > 0 && localDescription && localDescription.length > 0)
  {
    selectedTreatmentModalityTransformed = {value: localTreatmentModalityId, label: localDescription};
  }

  return (
    <>
    {editing ?
    <td style={{width: '350px'}}>
      <TreatmentModalitySelect providerId={providerId} handleTreatmentModalityChanged={handleTreatmentModalityChanged} selectedTreatmentModality={selectedTreatmentModalityTransformed}/>
    </td>
    :
    <td style={{width: '350px'}}>
      {localDescription}
    </td>
    }
    <td style={{width: '70px'}}>
      { canEdit?
        <>
        {editing ? 
        <>
          <X style={{'height': '16px', 'width': '16px'}} cursor="pointer" onClick={(e) => {cancelEdit(e)}} />
          &nbsp;<Check style={{'height': '16px', 'width': '16px'}} cursor="pointer" onClick={(e) => {saveEdit(e)}} className="text-success"/>
        </>
        :
        <>
          <Edit2 style={{'height': '12px', 'width': '12px'}} cursor="pointer" onClick={(e) => {handleEditClicked(e)}}/>&nbsp;&nbsp;
          <Trash2 style={{'height': '12px', 'width': '12px'}} cursor="pointer" onClick={(e) => {handleDeleteClicked(e)}}/>
        </>
        }
        </>
        : <>&nbsp;</>
      }
    </td>
  </>
  )
}


const TreatmentModalitiesTable = ({providerId, list, addingNew, onCancelAddNew, isLoaded, error, canEdit, refreshList}) => {
  const data = list;

  const columns = React.useMemo(
    () => [
      {
        accessor: "id",
        key: "id",
      },
      {
        accessor: "treatmentModalityId",
        key: "treatmentModalityId",
      },
      {
        Header: "Description",
        accessor: "description",
        key: "description",
      },
      {
        Header: "",
        accessor: "icons",
        key: "icons",
      },
    ],
  []
  )

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
  useTable(
    {
      columns,
      data,
      autoResetSortBy: false,
      autoResetFilters: false,
      initialState: {
        hiddenColumns: ['id', 'treatmentModalityId'],
        sortBy: [
            {
                id: 'description',
                desc: false
            }
        ],
      },
      sortTypes: {
        alphanumeric: (row1, row2, columnName) => caseInsensitiveSort({row1, row2, columnName})
      }
    },
    useFilters,
    useSortBy,
  );

  return (
    <Table className="table-sm" striped bordered hover {...getTableProps()}>
    <thead>
      {headerGroups.map((headerGroup) => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column) => {
            const { key, ...restHeaderProps } = (column.id === "icons") ? column.getHeaderProps() : column.getHeaderProps(column.getSortByToggleProps());
            return (
              <th {...restHeaderProps} key={key}>
                {column.render("Header")}
                {(column.id !== "icons") ? (
                  <>
                  {column.isSorted ? (
                      column.isSortedDesc ? (
                        <FontAwesomeIcon icon={faSortDown} className="ms-2" />
                      ) : (
                        <FontAwesomeIcon icon={faSortUp} className="ms-2" />
                      )
                    ) : (
                      <FontAwesomeIcon icon={faSort} className="ms-2" />
                  )}
                  </>
                ) : <></>
                }
              </th>
            )
          }
          )}
        </tr>
      ))}
    </thead>
    <tbody {...getTableBodyProps()}>
      {
      error ? (<tr><td colSpan={2}>Something went wrong; please reload the page...</td></tr>) : ( 
        !isLoaded ? (<tr><td colSpan={2}>Loading...</td></tr>) : (
          rows.map((row) => {
          prepareRow(row);
          const { key, ...restRowProps } = row.getRowProps();
          return (
            <tr {...restRowProps} key={key}>
              <ProviderTreatmentModality providerId={providerId} id={row.values.id} key={row.values.id} treatmentModalityId={row.values.treatmentModalityId} 
              description={row.values.description ? row.values.description : ""} refreshList={refreshList} canEdit={canEdit}/>
            </tr>
          );
        })))
      }
      {
      addingNew ?
        <tr><ProviderTreatmentModality providerId={providerId} key={0} startInEditMode={true} treatmentModalityId={0} description={""} onCancelEdit={onCancelAddNew} canEdit={canEdit} refreshList={refreshList}/></tr>
      : <></>
      }
    </tbody>
  </Table>
  )
}

const TreatmentModalities = ({providerId, canEdit}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [addingNew, setAddingNew] = useState(false);

  useEffect(() => {
    refreshList();
  }, [providerId])

  function refreshList()
  {
    setAddingNew(false);
    authenticatedFetch({
      path: "treatmentmodality/provider/" + providerId,
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result.treatmentModalities);
      },
      errorHandler: function() {
        setIsLoaded(true);
        setError(true);
      }
    });
  }

  const handleAddNewClicked = (e) => {
    e.preventDefault();
  
    setAddingNew(true);
  }

  const onCancelAddNew = () => {
    setAddingNew(false);
  }

  var list = [];
  if (isLoaded)
  {
    list = data.map((item, i) => {
      return {key: item.id, id: item.id, treatmentModalityId: item.treatmentModalityId, description: item.description, ageLowerBound: item.ageLowerBound, ageUpperBound: item.ageUpperBound};
    }, this);
  }

  return (
    <Card>
      <Card.Header style={{marginBottom: '-20px'}}>
        <Card.Title>Treatment Modalities
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <TreatmentModalitiesTable addingNew={addingNew} list={list} onCancelAddNew={onCancelAddNew} providerId={providerId} error={error} isLoaded={isLoaded} canEdit={canEdit} refreshList={refreshList}/>
        {canEdit?
          <span className="float-end" style={{marginTop: '6px'}}>
            <Button size="sm" variant="primary" className="float-end" onClick={(e) => {handleAddNewClicked(e)}}>+ Add New Treatment Modality</Button>
          </span>
          : <></>
        }
      </Card.Body>
    </Card>
  )
}

export default TreatmentModalities;
